import { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import Button from "../../../components/shared/buttons/button";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import useTranslator from "../../../hooks/useTranslator";
import {
  useCreateToastedSortingDataMutation,
  useUpdateToastedSortingDataMutation,
} from "./toastedApi";

const initialFormData = {
  prime_cheeks_kg: "",
  second_cheeks_kg: "",
  prime_strips_kg: "",
  second_strips_kg: "",
  tapita_kg: "",
  pieces_kg: "",
  rejected_kg: "",
};

const ToastedSortingModal = ({ show, setShow, record, mode }) => {
  const { _t } = useTranslator();
  const [formData, setFormData] = useState(initialFormData);

  const [createToastedSorting, { isLoading: isCreating }] = useCreateToastedSortingDataMutation();
  const [updateToastedSorting, { isLoading: isUpdating }] = useUpdateToastedSortingDataMutation();

  useEffect(() => {
    if (mode === "edit" && record) {
      setFormData({
        prime_cheeks_kg: record.prime_cheeks_kg ?? "",
        second_cheeks_kg: record.second_cheeks_kg ?? "",
        prime_strips_kg: record.prime_strips_kg ?? "",
        second_strips_kg: record.second_strips_kg ?? "",
        tapita_kg: record.tapita_kg ?? "",
        pieces_kg: record.pieces_kg ?? "",
        rejected_kg: record.rejected_kg ?? "",
      });
    } else {
      setFormData(initialFormData);
    }
  }, [mode, record, show]);

  const handleClose = () => setShow(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isCreating || isUpdating) return;
    const FmDt = {
        prime_cheeks_kg: formData.prime_cheeks_kg > 0 ? formData.prime_cheeks_kg : 0,
        second_cheeks_kg: formData.second_cheeks_kg > 0 ? formData.second_cheeks_kg : 0,
        prime_strips_kg: formData.prime_strips_kg > 0 ? formData.prime_strips_kg : 0,
        second_strips_kg: formData.second_strips_kg > 0 ? formData.second_strips_kg : 0,
        tapita_kg: formData.tapita_kg > 0 ? formData.tapita_kg : 0,
        pieces_kg: formData.pieces_kg > 0 ? formData.pieces_kg : 0,
        rejected_kg: formData.rejected_kg > 0 ? formData.rejected_kg : 0,
    };
    try {
      if (mode === "edit") {
        await updateToastedSorting({ id: record.id, requestBody: FmDt }).unwrap();
      } else {
        await createToastedSorting(FmDt).unwrap();
      }
      handleClose();
    } catch (error) {
      console.error("Error saving toasted sorting data:", error);
    }
  };

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={
        mode === "edit"
          ? _t("update_cheeks_strip_sorting_lot", "Update Cheeks/Strip Sorting Data")
          : _t("add_cheeks_strip_sorting_lot", "Add Cheeks/Strip Sorting Data")
      }
      children={formData}
    >
      <Row>
        <Col lg={6}>
          <InputWithLabel label={_t("prime_cheeks_kg", "Prime Cheeks Kg")} name="prime_cheeks_kg" type="number" value={formData.prime_cheeks_kg} onChange={handleChange} placeholder="0" />
        </Col>
        <Col lg={6}>
          <InputWithLabel label={_t("second_cheeks_kg", "Second Cheeks Kg")} name="second_cheeks_kg" type="number" value={formData.second_cheeks_kg} onChange={handleChange} placeholder="0" />
        </Col>
        <Col lg={6}>
          <InputWithLabel label={_t("prime_strips_kg", "Prime Strips Kg")} name="prime_strips_kg" type="number" value={formData.prime_strips_kg} onChange={handleChange} placeholder="0" />
        </Col>
        <Col lg={6}>
          <InputWithLabel label={_t("second_strips_kg", "Second Strips Kg")} name="second_strips_kg" type="number" value={formData.second_strips_kg} onChange={handleChange} placeholder="0" />
        </Col>
        <Col lg={6}>
          <InputWithLabel label={_t("tapita_kg", "Tapita Kg")} name="tapita_kg" type="number" value={formData.tapita_kg} onChange={handleChange} placeholder="0" />
        </Col>
        <Col lg={6}>
          <InputWithLabel label={_t("pieces_kg", "Pieces Kg")} name="pieces_kg" type="number" value={formData.pieces_kg} onChange={handleChange} placeholder="0" />
        </Col>
        <Col lg={6}>
          <InputWithLabel label={_t("trash", "Trash")} name="rejected_kg" type="number" value={formData.rejected_kg} onChange={handleChange} placeholder="0" />
        </Col>
      </Row>
      <Row>
        <Col className="text-end">
          <Button
            label={_t("save_changes", "Save Changes")}
            size="small"
            onClick={handleSubmit}
            disabled={isCreating || isUpdating}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default ToastedSortingModal;
